import { getMetadataEntityFieldType, MetadataEntityData, MetadataEntityFieldData, MetadataEntityFieldType } from '../decorators';
import { CustomFieldType } from '../../../entities';
import * as Enumerable from 'linq';



/**
 * @class MetadataImportValidationRow
 * This class is used to recursively loop through the metadata schema and build an flat list of fields that can be imported.
 */
export class MetadataImportFieldBuilder {

    public static getAvailableFields(entity: MetadataEntityData) {

        const available = this.getFields(entity);
        return available;

    }

    private static getFields(entity: MetadataEntityData, fields: MetadataEntityFieldData[] = []): MetadataEntityFieldData[] {

        Enumerable
            .from(entity?.fields)
            .where(x => x.importable && !x.readonly)
            .select(x => {
                if (x?.bulkImportOverrides) {
                    return { ...x, ...x.bulkImportOverrides };
                }
                return x;
            })
            .forEach(field => {

                const effectiveFieldType = MetadataImportFieldBuilder.getEffectiveFieldType(field);

                switch (effectiveFieldType) {
                    case MetadataEntityFieldType.EmbeddedEntity: {

                        const type = field.typeData as MetadataEntityData;

                        const childEntity = {
                            ...type,
                            fields: Enumerable
                                .from(type?.fields)
                                .where(x => x.importable && !x.readonly)
                                .where(x => ![MetadataEntityFieldType.Parent].includes(getMetadataEntityFieldType(x)))
                                .select(x => {
                                    return {
                                        ...x,
                                        displayName: `${field.displayName} ${x.displayName}`,
                                        path: `${field.path}.${x.path}`,
                                        group: `${field.displayName}`
                                    }
                                })
                                .toArray()
                        };

                        return this.getFields(childEntity, fields);
                    }

                    case MetadataEntityFieldType.Address: {
                        const type = field.typeData;
                        const addressFields = (type?.data?.fields ?? type?.fields ?? []) as MetadataEntityFieldData[];

                        // if (type.type === CustomFieldType.Address as any) {
                        //     type.fields = MetadataCatalog.getEntity(ActivityEntityName.Address).fields;
                        // }


                        fields.push(
                            ...Enumerable
                                .from(addressFields)
                                .select(x => {
                                    if (x?.bulkImportOverrides) {
                                        return { ...x, ...x.bulkImportOverrides };
                                    }
                                    return x;
                                })
                                .where(x => x.importable && !x.readonly)
                                .select(x => {
                                    return {
                                        ...x,
                                        required: x.required,
                                        displayName: `${field.displayName} ${x.displayName}`,
                                        path: `${field.path}.${x.path}`,
                                        group: `${field.group}`
                                    }
                                })
                                .toArray()
                        );
                        break;

                    }


                    case MetadataEntityFieldType.CustomFields: {
                        const type = field.typeData as MetadataEntityData;
                        fields.push(
                            ...Enumerable
                                .from(type?.fields)
                                .where(x => x.importable && !x.readonly)
                                .select(x => {
                                    return {
                                        ...x,
                                        displayName: `${field.displayName} ${x.displayName}`,
                                        path: `${field.path}.${x.path}`,
                                        group: `${field.group}`
                                    }
                                })
                                .toArray()
                        );
                        break;
                    }


                    default: {
                        fields.push({ ...field, group: entity.displayName });
                        break;
                    }

                }
            });

        return fields;

    }



    public static getEffectiveFieldType(field: MetadataEntityFieldData): MetadataEntityFieldType | [MetadataEntityFieldType] {

        if (!field.type)
            return MetadataEntityFieldType.None;

        if (field.type !== MetadataEntityFieldType.CustomFields && field.type !== MetadataEntityFieldType.CustomField)
            return field.type;

        const types = {
            [CustomFieldType.Address]: MetadataEntityFieldType.Address,
            [CustomFieldType.Dropdown]: MetadataEntityFieldType.String,
            [CustomFieldType.DropdownMulti]: [MetadataEntityFieldType.String],
            [CustomFieldType.Note]: MetadataEntityFieldType.String,
            [CustomFieldType.Text]: MetadataEntityFieldType.String,
            [CustomFieldType.Boolean]: MetadataEntityFieldType.Boolean,
            [CustomFieldType.Date]: MetadataEntityFieldType.Date,
            [CustomFieldType.DateTime]: MetadataEntityFieldType.DateTime,
            [CustomFieldType.Email]: MetadataEntityFieldType.Email,
            [CustomFieldType.Number]: MetadataEntityFieldType.Number,
            [CustomFieldType.Phone]: MetadataEntityFieldType.Phone
        }

        return types[field.typeData.type];
    }
}